import gql from 'gql-tag'

export const GET_PATIENT_NAME = gql`
  query GET_PATIENT_NAME($patientId: ID!) {
    Patient(id: $patientId) {
      id
      resourceType
      name {
        prefix
        given
        family
        suffix
        use
        text
      }
    }
  }
`

export const GET_PATIENT = gql`
  query GET_PATIENT($patientId: ID!) {
    Patient(id: $patientId) {
      id
      resourceType
      birthDate
      active
      name {
        prefix
        given
        family
        suffix
        use
        text
      }
      managingOrganization {
        id
        display
        reference
      }
      extension {
        url
        valueString
      }
      identifier {
        type {
          coding {
            display
            system
            code
          }
        }
        value
      }
      soc: ObservationList(
        _reference: patient
        code: "57201-6"
        status: "final"
        _sort: "-date"
        _count: 1
      ) {
        valueDateTime
      }
      nextRecert: ObservationList(
        _reference: patient
        code: "LA6355-7"
        status: "final"
        _sort: "-date"
        _count: 1
      ) {
        valueDateTime
      }
      CareTeamList(_reference: patient) {
        id
        name
        participant {
          role {
            text
          }
          member {
            resource {
              ... on Practitioner {
                resourceType
                id
                telecom {
                  system
                  value
                }
                PractitionerRoleList(_reference: practitioner) {
                  organization {
                    resource {
                      ... on Organization {
                        name
                        telecom {
                          system
                          value
                        }
                      }
                    }
                  }
                }
              }
            }
            id
            reference
            display
            identifier {
              id
            }
          }
        }
      }
    }
  }
`
